import React, { useEffect } from "react";
import styles from "./ShuffleGameSelection.module.scss";
import { SonicGameSelectionItem } from "../../../common/classes/SonicGameSelection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  items: Array<SonicGameSelectionItem>;
  shuffledIndex: Array<number>;
  handleShuffle: (shuffledIndex: Array<number>) => void;
};
const ShuffleGameSelection: React.FC<Props> = ({
  items,
  shuffledIndex,
  handleShuffle,
}) => {
  useEffect(() => {
    if (items.length > 1) {
      handleShuffle([...Array(items.length)].map((_, i) => i));
    }
  }, [items]);

  const upHandler = (index: number) => {
    if (index > 0 && shuffledIndex.length >= 2) {
      const array = shuffledIndex;
      array.splice(index - 1, 2, array[index], array[index - 1]);
      handleShuffle([...array]);
    }
  };

  const downHandler = (index: number) => {
    if (index >= 0 && shuffledIndex.length > index + 1) {
      const array = shuffledIndex;
      array.splice(index, 2, array[index + 1], array[index]);
      handleShuffle([...array]);
    }
  };

  return (
    <ul className={styles["shuffle-list"]}>
      {shuffledIndex.map((index, i) => (
        <li key={items[index].id} className={styles["shuffle-list__item"]}>
          <span className={styles["shuffle-list__item__name"]}>
            {items[index].value}
          </span>
          <span className={styles["shuffle-list__item__btn-area"]}>
            <button type="button" onClick={() => upHandler(i)}>
              <FontAwesomeIcon icon={["fas", "chevron-down"]} rotation={180} />
            </button>
            <button type="button" onClick={() => downHandler(i)}>
              <FontAwesomeIcon icon={["fas", "chevron-down"]} />
            </button>
          </span>
        </li>
      ))}
    </ul>
  );
};

export default ShuffleGameSelection;
